import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import RadioButton from "../../../common/RadioButton";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import {
  getHealthcareProxy,
  getHealthcareQuestionByCategory,
  postHealthcareProxy,
} from "../../../services/documentServices";
import { QuestionByCategoryType } from "../../../constants/constants";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const MainTeleCommunication = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [mailAndTelecommunication, setMailAndTeleCommunication] = useState([]);
  const [representaionInCourt, setRepresentationInCourt] = useState([]);
  const [consantRepresentation, setConsantRepresentation] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchCourtRepresentation() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.COURT_REPRESENTATION,
      uID
    );
    if (result?.success) {
      setRepresentationInCourt(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }
  async function fetchMailTele() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.MAIL_TELE_COMUNICATION,
      uID
    );
    if (result?.success) {
      setMailAndTeleCommunication(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }

  async function fetchConsantRepresentation() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.ConsantRepresentation,
      uID
    );
    if (result?.success) {
      setConsantRepresentation(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }
  useEffect(() => {
    fetchData();
    fetchCourtRepresentation()
    fetchMailTele();
    fetchConsantRepresentation();
  }, []);
  const setYes = (e, type) => {
    if (type === "representation") {
      const updateList = {
        ...representaionInCourt,
        data: representaionInCourt?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: true,
            }
            : ele
        })
      }
      setRepresentationInCourt(updateList);
    } else if (type === "mail") {

      const updateList = {
        ...mailAndTelecommunication,
        data: mailAndTelecommunication?.data?.map((ele) => {
          return ele.id == e.id ? { ...ele, yes: true } : ele;
        })
      }
      setMailAndTeleCommunication(updateList);
    } else if (type === "consant") {
      const updateList = {
        ...consantRepresentation,
        data: consantRepresentation?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: true,
            }
            : ele;
        })
      }
      setConsantRepresentation(updateList);
    }
  };
  const setNo = (e, type) => {
    if (type === "representation") {
      const updateList = {
        ...representaionInCourt,
        data: representaionInCourt?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: false,
            }
            : ele;
        })
      }
      setRepresentationInCourt(updateList);
    } else if (type === "mail") {

      const updateList = {
        ...mailAndTelecommunication,
        data: mailAndTelecommunication?.data?.map((ele) => {
          return ele.id == e.id ? { ...ele, yes: false } : ele;
        })
      }
      setMailAndTeleCommunication(updateList);
    } else if (type === "consant") {
      const updateList = {
        ...consantRepresentation,
        data: consantRepresentation?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: false,
            }
            : ele
        })
      };
      setConsantRepresentation(updateList);
    }
  }


  const setAllTrue = (currentObj) => currentObj.yes == true;

  const handleSubmit = async () => {
    setButtonDisabled(true);
    const payload = {
      ...data,
      healthProxyAnswers: [
        ...data.healthProxyAnswers,
        ...mailAndTelecommunication?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
        ...representaionInCourt?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
        ...consantRepresentation?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
      ],
      checkListTab4:
        mailAndTelecommunication?.data?.every(setAllTrue) &&
          representaionInCourt?.data?.every(setAllTrue) &&
          consantRepresentation.data.every(setAllTrue)
          ? 2
          : 1,
    };
    const result = await postHealthcareProxy(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  return (
    <form
      id="form_submit"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      className="summary-table documents-card-height"
    >
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%" className="medical-care-container">
          <Typography variant="p" fontWeight="bold">
            {t(mailAndTelecommunication?.title?.translationKey)}
          </Typography>
          <Box padding="0 2rem" component="div" className="section-1">
            <Box component="div" className="sub-section-1">
              <Typography variant="p" marginRight="1rem">
                {t("YES")}
              </Typography>
              <Typography variant="p">{t("NO")}</Typography>
            </Box>
            <ol>
              {mailAndTelecommunication?.data?.length > 0 && mailAndTelecommunication?.data?.map((elem, index) => {
                return (
                  <li>
                    <Box component="div" key={index} className="sub-section-2">
                      <Typography variant="p" margin="0 0.5rem" width="80%">
                        {elem?.translationKey ? t(elem.translationKey) : ""}
                      </Typography>
                      <RadioButton
                        value="0"
                        theme="box"
                        paddingLeft="1rem"
                        checked={elem.yes}
                        onChange={() => {
                          setYes(elem, 'mail');
                        }}
                      />
                      <RadioButton
                        value="1"
                        theme="box"
                        checked={!elem.yes && elem.yes != null}
                        onChange={() => {
                          setNo(elem, "mail");
                        }}
                      />
                    </Box>
                  </li>
                );
              })}
            </ol>
          </Box>


          <Typography variant="p" fontWeight="bold">
            {" "}
            {t(representaionInCourt?.title?.translationKey)}{" "}
          </Typography>{" "}
          <Box
            padding="0 2rem"
            component="div"
            className="section-1"
            style={{
              width: "100%",
            }}
          >
            <Box component="div" className="sub-section-1">
              <Typography variant="p" marginRight="1rem">
                {" "}
                {t("YES")}{" "}
              </Typography>{" "}
              <Typography variant="p"> {t("NO")} </Typography>{" "}
            </Box>{" "}
            <ol>
              {" "}
              {representaionInCourt?.data?.length > 0 && representaionInCourt?.data?.map((elem, index) => {
                return (
                  <li>
                    <Box component="div" key={index} className="sub-section-2">
                      <Typography variant="p" margin="0 0.5rem" width="80%">
                        {" "}
                        {elem?.translationKey
                          ? t(elem.translationKey)
                          : ""}{" "}
                      </Typography>{" "}
                      <RadioButton
                        value="0"
                        theme="box"
                        paddingLeft="1rem"
                        checked={elem.yes}
                        onChange={() => {
                          setYes(elem, "representation");
                        }}
                      />{" "}
                      <RadioButton
                        value="1"
                        theme="box"
                        checked={!elem.yes && elem.yes != null}
                        onChange={() => {
                          setNo(elem, "representation");
                        }}
                      />{" "}
                    </Box>{" "}
                  </li>
                );
              })}{" "}
            </ol>{" "}
          </Box>


          <Typography variant="p" fontWeight="bold" className="mt-5">
            {" "}
            {t(consantRepresentation?.title?.translationKey)}{" "}
          </Typography>{" "}
          <Box
            padding="0 2rem"
            component="div"
            className="section-1"
            style={{
              width: "100%",
            }}
          >
            <Box component="div" className="sub-section-1">
              <Typography variant="p" marginRight="1rem">
                {" "}
                {t("YES")}{" "}
              </Typography>{" "}
              <Typography variant="p"> {t("NO")} </Typography>{" "}
            </Box>{" "}
            <ol>
              {" "}
              {consantRepresentation?.data?.length > 0 && consantRepresentation?.data?.map((elem, index) => {
                return (
                  <>
                    <li key={index}>
                      {" "}
                      <Box
                        component="div"
                        key={index}
                        className="sub-section-2"
                      >
                        <Typography variant="p" margin="0 0.5rem" width="80%">
                          {" "}
                          {elem?.translationKey
                            ? t(elem.translationKey)
                            : ""}{" "}
                        </Typography>{" "}

                        <RadioButton
                          value="0"
                          theme="box"
                          paddingLeft="1rem"
                          checked={elem.yes}
                          onChange={() => {
                            setYes(elem, "consant");
                          }}
                        />{" "}
                        <RadioButton
                          value="1"
                          theme="box"
                          checked={!elem.yes && elem.yes != null}
                          onChange={() => {
                            setNo(elem, "consant");
                          }}
                        />{" "}

                      </Box>{" "}
                    </li>{" "}
                  </>
                );
              })}{" "}
            </ol>{" "}
          </Box>{" "}
        </Box>
      )}
    </form>
  );
};

export default MainTeleCommunication;
